<template>
  <div class="addEmployeeSkillVue">
    <div class="c-responsive-fixwidth">
               <div class="clearfix o-skillset-area">
                   <div class="employer-info">
                       <div class="field-group">
                           <div class="row">
                               <div class="col-sm-12">
                                   <div class="c-common-space c-radius3">
                                       <div class="col-sm-3 skillset o-no-padding o-skill-auth"><span class="common-label-text">Authority:</span>
                                           <ul>
                                               <li>
                                                   <form>
                                                       <div class="radio o-custom-radio">
                                                           <label>
                                                               Locked
                                                               <input type="radio" name="o3" v-model="updateAuthority" value="locked" @change="onUpdateInputField">
                                                               <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                                           </label>
                                                       </div>
                                                       <div class="radio o-custom-radio">
                                                           <label>
                                                               Unlocked
                                                               <input type="radio" name="o3" v-model="updateAuthority" value="unlocked" @change="onUpdateInputField">
                                                               <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                                           </label>
                                                       </div>
                                                   </form>
                                               </li>
                                           </ul>
                                       </div>
                                       <div class="col-sm-9 skillset"><span class="common-label-text">Action:</span>
                                           <button @click="selectAllSkill()" type="submit" class="c-common-btn o-no-margin" :class="(selectedFilter == 'all')?'o-filter-active':''">All</button>
                                           <button @click="selectNone()" type="submit" class="c-common-btn o-no-margin" :class="(selectedFilter == 'none')?'o-filter-active':''">None</button>
                                       </div>

                                   </div>
                                   <div class="c-common-space c-common-box-shadow c-radius3">
                                       <div class="c-user-tab-content clearfix o-skillset-area">
                                           <div v-loading="loading" class="row">
                                               <form class="common-scroll">
                                                   <div v-for="skill in skillList" class="col-sm-3">
                                                       <div class="checkbox o-custom-checkbox clearfix">
                                                           <label>
                                                                {{skill.name}}
                                                               <input type="checkbox" name="o4" :value="skill.id" v-model="selectedSkills" @change="onUpdateInputField">
                                                               <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                           </label>
                                                       </div>
                                                   </div>
                                               </form>
                                           </div>
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div>
                   </div>
               </div>
           </div>
  </div>
</template>
<script>
    import dateTimeConvert from '../../timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../services.js';
    import {
        bus
    } from '../../main';
    export default {
        props: {
            skillData: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                skillList: [],
                selectedSkills: [],
                loading: false,
                updateAuthority: 'locked',
                selectedFilter: 'none',
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
            })
        },
        methods: {
            selectAllSkill() {
                this.selectedFilter = 'all';
                let self = this;
                this.skillList.forEach(function(skill) {
                    self.selectedSkills.push(skill.id);
                    //console.log(emp.employable.id);
                });
                this.onUpdateInputField();
            },
            selectNone() {
                this.selectedFilter = 'none';
                this.selectedSkills = [];
                this.onUpdateInputField();
            },
            onUpdateInputField() {
                //this.$store.dispatch('saveEmployeeBasicInfo', this.empPersonal.basicInfo);
                let skillData = {
                    selectedSkills: this.selectedSkills,
                    updateAuthority: this.updateAuthority,
                };
                bus.$emit('onUpdateSkillList', skillData);
            }
        },
        created() {
            this.selectedSkills = this.skillData.selectedSkills;
            this.updateAuthority = this.skillData.updateAuthority;

            this.loading = true;
            service.get('skill/getAllSkills', {
                'Authorization': this.userToken,
                'cs3-context-role': this.userRole,
                'cs3-context-clientId': this.userClientID
            }).
            then((res) => {
                this.skillList = res.data.result;
                this.loading = false;
                //console.log(this.skillList);

            }).catch((err) => {
                console.log(err);
                this.loading = false;
            });
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/employees/addEmployeeSkills.vue